import { render, staticRenderFns } from "./BaseSort.vue?vue&type=template&id=c08c5056"
import script from "./BaseSort.vue?vue&type=script&lang=js"
export * from "./BaseSort.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports